import { common } from 'themes/rebrand';
import { PLUS, PREMIER, STANDARD } from './classOfService';

export const B = 'B';
export const H = 'H';
export const A = 'A';
export const C = 'C';
export const W = 'W';

export const TB = 'TB';
export const TH = 'TH';
export const TA = 'TA';
export const TW = 'TW';
export const TC = 'TC';

export const KL = 'KL';
export const E = 'E';
export const EB = 'EB';
export const EH = 'EH';
export const EA = 'EA';
export const X = 'X';
export const Y = 'Y';
export const Z = 'Z';

export const TU = 'TU';

export const SEAT_SELECTION_INVENTORY_CLASSES = [B, H, A, C, W, TH, TB, TA, TW, TC, KL, E, EB, EH, EA, X, Y, Z, TU];

export const INVENTORY_CLASSES = {
  B,
  H,
  A,
  C,
  W,
  TH,
  TB,
  TA,
  TW,
  TC,
  KL,
  E,
  EB,
  EH,
  EA,
  X,
  Y,
  Z,
  TU
};

export const NEW_CLASS_OF_SERVICE_MAP_NAMES = {
  [B]: {
    name: 'Std',
    color: common.classes[STANDARD]
  },
  [TB]: {
    name: 'Std',
    color: common.classes[STANDARD]
  },
  [H]: {
    name: 'Plus',
    color: common.classes[PLUS]
  },
  [TH]: {
    name: 'Plus',
    color: common.classes[PLUS]
  },
  [A]: {
    name: 'Prem',
    color: common.classes[PREMIER]
  },
  [TA]: {
    name: 'Prem',
    color: common.classes[PREMIER]
  },
  [E]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EB]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EH]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EA]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [X]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [Y]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [Z]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  }
};

export const OLD_CLASS_OF_SERVICE_MAP_NAMES = {
  [B]: {
    name: 'STD',
    color: common.classes[STANDARD]
  },
  [TB]: {
    name: 'Standard',
    color: common.classes[STANDARD]
  },
  [H]: {
    name: 'SP',
    color: common.classes[PLUS]
  },
  [TH]: {
    name: 'Comfort',
    color: common.classes[PLUS]
  },
  [A]: {
    name: 'BP',
    color: common.classes[PREMIER]
  },
  [TA]: {
    name: 'Premium',
    color: common.classes[PREMIER]
  },
  [E]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EB]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EH]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [EA]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [X]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [Y]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  },
  [Z]: {
    name: 'Evac',
    color: common.classes[PREMIER]
  }
};

export const AVAILABLE_SEATS_ORDERING = [A, TA, H, TH, B, TB, W, TW, C, TC];

export const DISALLOWED_CLASSES = new Set([W, C, TW, TC, KL]);
export const COMPANION_CLASSES = new Set([C, TC]);
